import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface HasValidPhoneOtcResponse extends BackendResponse {
  /** True when an unconsumed, unexpired, under-attempt-cap code is already on
   *  file for this phone — so the client can skip the "send code" intro step. */
  hasValid: boolean;
}

export interface HasValidPhoneOtcParameters extends NextApiParams {
  phone: string;
}

export const hasValidPhoneOtc = withNextApi<
  HasValidPhoneOtcResponse,
  HasValidPhoneOtcParameters
>("/auth/HasValidPhoneOtc", {
  method: "GET",
});
